/**
 * AB#21576 — column widths a person has dragged, remembered on this browser.
 *
 * One call per grid, keyed by the page's column-visibility key so the widths
 * live next to the hidden-column choice (`dashboardColumns` →
 * `dashboardColumnWidths`). The DataTable owns the drag; this owns the memory.
 */
import { ref } from 'vue';
import {
  columnWidthsKey,
  readColumnWidths,
  writeColumnWidths,
  type ColumnWidths,
  type StorageLike,
} from '@/utils/tablePreferences';

const browserStorage = (): StorageLike | null => {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
};

export const useColumnWidths = (columnPrefKey: string) => {
  const key = columnWidthsKey(columnPrefKey);
  const storage = browserStorage();
  const columnWidths = ref<ColumnWidths>(readColumnWidths(storage, key));

  const setColumnWidths = (widths: ColumnWidths) => {
    columnWidths.value = { ...widths };
    writeColumnWidths(storage, widths, key);
  };

  const resetColumnWidths = () => setColumnWidths({});

  return { columnWidths, setColumnWidths, resetColumnWidths };
};
